{"loading":"Loading...","error":"An error occurred","notFound":"Not Found"}